<template>
  <div>
    <h2>Teams</h2>
    <table>
      <thead>
        <tr>
          <th @click="sort('team_id')">Team ID</th>
          <th @click="sort('team_name')">Team Name</th>
          <th>Edit</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="team in sortedTeams" :key="team.team_id">
          <td>{{ team.team_id }}</td>
          <td>{{ team.team_name }}</td>
          <td><button class="buttons-short" @click="editTeam(team)">Edit</button></td>
          <td><button class="buttons-short" @click="deleteTeam(team.team_id)">Delete</button></td>
        </tr>
      </tbody>
    </table>
    <div v-if="showEditTeamForm">
      <h3>Edit Team</h3>
      <input v-model="editTeamName" placeholder="Team Name" />
      <button @click="updateTeam">Update</button>
      <button @click="showEditTeamForm = false">Cancel</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'OrgAllTeams',
  data() {
    return {
      teams: [],
      sortKey: '',
      sortAsc: true,
      showEditTeamForm: false,
      editTeamName: '',
      editTeamId: null,
    };
  },
  computed: {
    orgId() {
      return this.$store.getters.getUser.orgId;
    },
    sortedTeams() {
      return [...this.teams].sort((a, b) => {
        let result = 0;
        if (a[this.sortKey] < b[this.sortKey]) result = -1;
        if (a[this.sortKey] > b[this.sortKey]) result = 1;
        return this.sortAsc ? result : -result;
      });
    },
  },
  methods: {
    async fetchTeams() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_SERVER_HOST}/teams/getAllTeams`);
        this.teams = response.data.filter(team => team.org_id === this.orgId);
      } catch (error) {
        console.error('Error fetching teams:', error);
      }
    },
    sort(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        this.sortAsc = true;
      }
    },
    editTeam(team) {
      this.$emit('edit-team', team);
    },
    async deleteTeam(teamId) {
      try {
        await axios.delete(`${process.env.VUE_APP_SERVER_HOST}/teams/deleteTeam/${teamId}`);
        this.teams = this.teams.filter(team => team.team_id !== teamId);
      } catch (error) {
        console.error('Error deleting team:', error);
      }
    },
  },
  mounted() {
    this.fetchTeams();
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
th, td {
  border: 1px solid #ddd;
  padding: 8px;
}
th {
  cursor: pointer;
  background-color: #656565;
}
button {
  margin: 5px;
}
</style>